import React, { useEffect, useState } from 'react'
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CImage,
  CRow,
  CAlert,
  CForm,
  CFormLabel,
  CFormTextarea,
  CStack,
} from '@coreui/react'
import {
  cilPhone,
  cilXCircle,
  cilStar,
  cilArrowCircleLeft,
  //cilVerticalAlignCenter,
  cilSave,
  cilCopy,
  cilHandshake,
  cilChevronTop,
  cilChevronBottom,
  cilList,
  cilSend,
  cilSpreadsheet,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import apiClient from '../../services/apiClient'
import { isNull, set } from 'lodash'
import { buildApiUrl } from '../../utils/getConfiguration'
import InternalAppHeader from './components/InternalAppHeader'
import { useTranslation } from 'react-i18next'
import { SplashScreen } from '@capacitor/splash-screen'

const SuppliersInnoProjectStatus = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [visible1, setVisible1] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [ideaDescriptions, setIdeaDescriptions] = useState({}) // změna názvu a struktury stavu
  const [ideaScopes, setIdeaScopes] = useState({}) // změna názvu a struktury stavu
  const [ideaScopesStatus, setIdeaScopesStatus] = useState({}) // změna názvu a struktury stavu
  const [ideaTimelines, setIdeaTimelines] = useState({}) // změna názvu a struktury stavu
  const [ideaTimelinesStatus, setIdeaTimelinesStatus] = useState({}) // změna názvu a struktury stavu
  const [ideaBudgets, setIdeaBudgets] = useState({}) // změna názvu a struktury stavu
  const [ideaBudgetsStatus, setIdeaBudgetsStatus] = useState({}) // změna názvu a struktury stavu
  const [ideaResources, setIdeaResources] = useState({}) // změna názvu a struktury stavu
  const [ideaResourcesStatus, setIdeaResourcesStatus] = useState({}) // změna názvu a struktury stavu
  const [ideaRisks, setIdeaRisks] = useState({}) // změna názvu a struktury stavu
  const [ideaRisksStatus, setIdeaRisksStatus] = useState({}) // změna názvu a struktury stavu
  const [ideaVendors, setIdeaVendors] = useState({}) // změna názvu a struktury stavu
  const [ideaVendorsStatus, setIdeaVendorsStatus] = useState({}) // změna názvu a struktury stavu

  const [formData, setFormData] = useState({
    scope: '',
    time: '',
    budget: '',
    resources: '',
    risk: '',
    vendor: '',
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    // Sem můžeš dát odeslání na API
    console.log('Odesláno:', formData)
    console.log('Idea descriptions:', ideaDescriptions)
    console.log('Idea timelines:', ideaTimelines)
    console.log('Idea budgets:', ideaBudgets)
    console.log('Idea resources:', ideaResources)
    console.log('Idea risks:', ideaRisks)
    console.log('Idea vendors:', ideaVendors)
    //setSubmitted(true)
  }

  const fetchSuppliersData = async () => {
    try {
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(buildApiUrl('suppliers', { grp_ID }))
      setSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchSuppliersData()
  }, [])

  const [prefsuppliers, setPrefSuppliers] = useState([])

  const fetchPrefSuppliersData = async () => {
    try {
      const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const params = {
        reminder_ID,
        account_ID,
        grp_ID,
      }
      console.log('Preferred supplier params', params)
      const response = await apiClient.get(buildApiUrl('supplierPref', params))
      setPrefSuppliers(response.data)
    } catch (error) {
      console.error('Error fetching supplier', error)
    }
  }

  useEffect(() => {
    if (
      String(localStorage.getItem('supplierid')) === 'null' &&
      String(localStorage.getItem('suppliertel')) === 'null'
    ) {
      console.log('Needed supplier')
      setVisible(true)
    } else {
      console.log('Not needed supplier')
      setVisible(false)
    }
    console.log(localStorage.getItem('suppliertel'))
    fetchPrefSuppliersData()
  }, [])

  const [startups, setStartups] = useState([])

  const fetchInnovationsData = async () => {
    try {
      const account_ID = localStorage.getItem('account_ID')
      const response = await apiClient.get(buildApiUrl('startupsList', { account_ID }))
      setStartups(response.data)

      // Inicializace hodnot pro každý startup
      const initialScopes = {}
      const initialScopesStatus = {}
      const initialTimelinesStatus = {}
      const initialTimelines = {}
      const initialBudgetsStatus = {}
      const initialBudgets = {}
      const initialResourcesStatus = {}
      const initialResources = {}
      const initialRisksStatus = {}
      const initialRisks = {}
      const initialVendorsStatus = {}
      const initialVendors = {}
      response.data.forEach((startup) => {
        initialScopes[startup.startup_id] = Array.isArray(startup.scope)
          ? startup.scope[0] || ''
          : startup.scope || ''
        initialScopesStatus[startup.startup_id] = Array.isArray(startup.scope_status)
          ? startup.scope_status[0] || ''
          : startup.scope_status || ''
        initialTimelines[startup.startup_id] = Array.isArray(startup.timeline)
          ? startup.timeline[0] || ''
          : startup.timeline || ''
        initialTimelinesStatus[startup.startup_id] = Array.isArray(startup.timeline_status)
          ? startup.timeline_status[0] || ''
          : startup.timeline_status || ''
        initialBudgets[startup.startup_id] = Array.isArray(startup.budget)
          ? startup.budget[0] || ''
          : startup.budget || ''
        initialBudgetsStatus[startup.startup_id] = Array.isArray(startup.budget_status)
          ? startup.budget_status[0] || ''
          : startup.budget_status || ''
        initialResources[startup.startup_id] = Array.isArray(startup.resources)
          ? startup.resources[0] || ''
          : startup.resources || ''
        initialResourcesStatus[startup.startup_id] = Array.isArray(startup.resources_status)
          ? startup.resources_status[0] || ''
          : startup.resources_status || ''
        initialRisks[startup.startup_id] = Array.isArray(startup.risks)
          ? startup.risks[0] || ''
          : startup.risks || ''
        initialRisksStatus[startup.startup_id] = Array.isArray(startup.risks_status)
          ? startup.risks_status[0] || ''
          : startup.risks_status || ''
        initialVendors[startup.startup_id] = Array.isArray(startup.vendor)
          ? startup.vendor[0] || ''
          : startup.vendor || ''
        initialVendorsStatus[startup.startup_id] = Array.isArray(startup.vendor_status)
          ? startup.vendor_status[0] || ''
          : startup.vendor_status || ''
      })
      setIdeaScopes(initialScopes)
      setIdeaScopesStatus(initialScopesStatus)
      setIdeaTimelines(initialTimelines)
      setIdeaTimelinesStatus(initialTimelinesStatus)
      setIdeaBudgets(initialBudgets)
      setIdeaBudgetsStatus(initialBudgetsStatus)
      setIdeaResources(initialResources)
      setIdeaResourcesStatus(initialResourcesStatus)
      setIdeaRisks(initialRisks)
      setIdeaRisksStatus(initialRisksStatus)
      setIdeaVendors(initialVendors)
      setIdeaVendorsStatus(initialVendorsStatus)
    } catch (error) {
      console.error('Error fetching suppliers', error)
    }
  }

  useEffect(() => {
    fetchInnovationsData()
  }, [])

  useEffect(() => {
    const splash = document.getElementById('splash-screen')
    if (splash) splash.style.display = 'none'
    if (window?.SplashScreen?.hide) {
      window.SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen on innovation status', error)
      })
    } else if (SplashScreen?.hide) {
      SplashScreen.hide({ fadeOutDuration: 200 }).catch((error) => {
        console.warn('Unable to hide splash screen on innovation status', error)
      })
    }
  }, [])

  const handleClickUnassign = async (startup_ID) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      await apiClient.get(
        buildApiUrl('startupUnassign', {
          startup_ID,
          account_ID,
        }),
      )
      //localStorage.setItem('supplierid', 'null')
      //localStorage.setItem('suppliertel', 'null')
      fetchInnovationsData()
      setVisible(true)
      console.log('Unassigned startup ' + startup_ID)
      //localStorage.removeItem('supplierid')
      //window.history.back()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const handleClickSave = async (startup_ID, scope, timeline, budget, resources, risks, vendor) => {
    try {
      console.log('Account_ID ' + localStorage.getItem('account_ID'))
      console.log('Scope status ' + scope)
      console.log('Timeline status ' + timeline)
      console.log('Budget status ' + budget)
      console.log('Resources status ' + resources)
      console.log('Risks status ' + risks)
      console.log('Vendor status ' + vendor)
      //console.log('Reminder_ID ' + localStorage.getItem('taskid'))
      //console.log('Supplier_ID ' + localStorage.getItem('supplierid'))

      //const reminder_ID = localStorage.getItem('taskid')
      const account_ID = localStorage.getItem('account_ID')
      //const supplier_ID = localStorage.getItem('supplierid')
      //const supplier_name = name
      //const supplier_contact_name = contact
      //const supplier_contact_tel = tel
      await apiClient.get(
        buildApiUrl('startupIdeaSaveProjectStatus', {
          account_ID,
          startup_ID,
          scope_status: scope,
          timeline_status: timeline,
          budget_status: budget,
          resources_status: resources,
          risks_status: risks,
          vendor_status: vendor,
        }),
      )
      // Example: buildApiUrl('startupAssign', { account_ID: 3, startup_ID: 1, idea: 'Test' })
      fetchInnovationsData()
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  function mergeTel(str1) {
    return 'tel:' + str1
  }

  function getIdeaTypeLabel(type) {
    switch (type) {
      case 'F':
        return t('innovationStatus.ideaTypes.favorite')
      case 'C':
        return t('innovationStatus.ideaTypes.copy')
      case 'J':
        return t('innovationStatus.ideaTypes.joint')
      case isNull(type):
        return ''
    }
  }

  return (
    <div className="buying-list-wrapper min-vh-100 d-flex flex-column">
      <CContainer className="py-4 flex-grow-1">
        <InternalAppHeader
          title={t('innovationStatus.header')}
          onBack={() => window.history.back()}
        />

        <CRow className="justify-content-center g-4 mt-2">
          <CCol lg={10}>
            <CCard className="mb-4 border-0 shadow-sm">
              <CCardBody className="py-4">
                {startups.length > 0 ? (
                  <CAccordion flush>
                    {startups.map((startup) => {
                      const ideaType = getIdeaTypeLabel(
                        startup.ideaType ?? startup.idea_type ?? startup.type,
                      )
                      return (
                        <CAccordionItem
                          itemKey={String(startup.startup_id)}
                          key={startup.startup_id}
                          className="mb-3"
                        >
                          <CAccordionHeader>
                            <div className="d-flex align-items-center gap-3">
                              <CImage
                                rounded
                                orientation="top"
                                src={`https://www.emerkur.eu/startups/${startup.pic}`}
                                width={64}
                                className="flex-shrink-0 shadow-sm"
                                style={{ height: 'auto', objectFit: 'contain' }}
                              />
                              <div className="text-start">
                                <div className="fw-semibold">
                                  {startup.idea || t('innovationStatus.fields.ideaTitleFallback')}
                                </div>
                                {ideaType && (
                                  <small className="text-uppercase text-muted">{ideaType}</small>
                                )}
                              </div>
                            </div>
                          </CAccordionHeader>
                          <CAccordionBody>
                            <CForm>
                              <CRow className="g-4">
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaScopeDescription-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.scope')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaScopeDescription-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t('innovationStatus.fields.scopePlaceholder')}
                                      value={ideaScopes[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaScopeDescriptionStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.scopeStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaScopeDescriptionStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.scopeStatusPlaceholder',
                                      )}
                                      value={ideaScopesStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaScopesStatus({
                                          ...ideaScopesStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaTimeline-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.timeline')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaTimeline-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t('innovationStatus.fields.timelinePlaceholder')}
                                      value={ideaTimelines[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaTimelineStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.timelineStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaTimelineStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.timelineStatusPlaceholder',
                                      )}
                                      value={ideaTimelinesStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaTimelinesStatus({
                                          ...ideaTimelinesStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaBudget-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.budget')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaBudget-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t('innovationStatus.fields.budgetPlaceholder')}
                                      value={ideaBudgets[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaBudgetStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.budgetStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaBudgetStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.budgetStatusPlaceholder',
                                      )}
                                      value={ideaBudgetsStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaBudgetsStatus({
                                          ...ideaBudgetsStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaResource-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.resources')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaResource-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t(
                                        'innovationStatus.fields.resourcesPlaceholder',
                                      )}
                                      value={ideaResources[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaResourceStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.resourcesStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaResourceStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.resourcesStatusPlaceholder',
                                      )}
                                      value={ideaResourcesStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaResourcesStatus({
                                          ...ideaResourcesStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaRisk-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.risks')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaRisk-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t('innovationStatus.fields.risksPlaceholder')}
                                      value={ideaRisks[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaRiskStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.risksStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaRiskStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.risksStatusPlaceholder',
                                      )}
                                      value={ideaRisksStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaRisksStatus({
                                          ...ideaRisksStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaVendor-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.vendor')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaVendor-${startup.startup_id}`}
                                      rows={2}
                                      disabled
                                      placeholder={t('innovationStatus.fields.vendorPlaceholder')}
                                      value={ideaVendors[startup.startup_id] || ''}
                                    />
                                  </div>
                                </CCol>
                                <CCol md={6}>
                                  <div className="d-flex flex-column gap-2 border-top pt-3">
                                    <CFormLabel
                                      htmlFor={`ideaVendorStatus-${startup.startup_id}`}
                                      className="fw-semibold"
                                    >
                                      {t('innovationStatus.fields.vendorStatus')}
                                    </CFormLabel>
                                    <CFormTextarea
                                      id={`ideaVendorStatus-${startup.startup_id}`}
                                      rows={2}
                                      placeholder={t(
                                        'innovationStatus.fields.vendorStatusPlaceholder',
                                      )}
                                      value={ideaVendorsStatus[startup.startup_id] || ''}
                                      onChange={(e) =>
                                        setIdeaVendorsStatus({
                                          ...ideaVendorsStatus,
                                          [startup.startup_id]: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </CCol>
                                <CCol xs={12}>
                                  <div className="border-top pt-3 d-flex justify-content-start">
                                    <div className="d-flex gap-2">
                                      <CButton
                                        color="success"
                                        onClick={() => {
                                          console.log(
                                            'Save idea for startup Nr.' + startup.startup_id,
                                          )
                                          handleClickSave(
                                            startup.startup_id,
                                            ideaScopesStatus[startup.startup_id] || '',
                                            ideaTimelinesStatus[startup.startup_id] || '',
                                            ideaBudgetsStatus[startup.startup_id] || '',
                                            ideaResourcesStatus[startup.startup_id] || '',
                                            ideaRisksStatus[startup.startup_id] || '',
                                            ideaVendorsStatus[startup.startup_id] || '',
                                          )
                                        }}
                                      >
                                        <CIcon icon={cilSave} className="me-2" />
                                        {t('innovationStatus.buttons.save')}
                                      </CButton>
                                      <CButton
                                        color="danger"
                                        variant="outline"
                                        onClick={() => {
                                          console.log('Unassigned startup ' + startup.startup_id)
                                          handleClickUnassign(startup.startup_id)
                                        }}
                                      >
                                        <CIcon icon={cilXCircle} className="me-2" />
                                        {t('innovationStatus.buttons.unassign')}
                                      </CButton>
                                    </div>
                                  </div>
                                </CCol>
                              </CRow>
                            </CForm>
                          </CAccordionBody>
                        </CAccordionItem>
                      )
                    })}
                  </CAccordion>
                ) : (
                  <CAlert color="info" className="mb-0">
                    {t('innovationStatus.empty')}
                  </CAlert>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default SuppliersInnoProjectStatus
